import { forwardRef } from 'react';
import { type DetailedHTMLProps, type SyntheticEvent } from 'react';

import silverIcon from './silver-icon.webp';

type Props = Omit<
  DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement | null>,
    HTMLDivElement
  >,
  'onClick'
> & {
  onClick?: (e: SyntheticEvent) => void;
};
export const SilverIcon = forwardRef<HTMLDivElement, Props>(
  (props: Props, ref) => {
    return (
      <div className="text-text400 flex text-sm" {...props} ref={ref}>
        <div className="flex flex-col justify-center">
          <img alt="silver-icon" className="h-[38px]" src={silverIcon} />
        </div>
        <div className="-mt-[6px] flex flex-col justify-center text-center">
          <span>Silver</span>
        </div>
      </div>
    );
  }
);

SilverIcon.displayName = 'SilverIcon';
